export function isEqual(value) {
  return JSON.stringify(value) || '{}';
}